import { RootReducerState } from '../reducers';
import { ConfigurationReducerState } from '../reducers/configuration';

/** localStorage key for persisted NgRx slices (versioned to invalidate legacy full-store blobs). */
export const PERSIST_STORAGE_KEY = 'ngrx-persist-v3';

/** Legacy key written by the previous meta-reducer. */
export const LEGACY_PERSIST_STORAGE_KEY = 'state';

/** Only non-sensitive UI preferences are restored across reloads. */
export interface PersistedRootState {
  config: Pick<ConfigurationReducerState, 'menu' | 'pdf_generator'>;
}

export function pickPersistedState(state: RootReducerState): PersistedRootState {
  return {
    config: {
      menu: state.config.menu,
      pdf_generator: state.config.pdf_generator,
    },
  };
}

export function mergePersistedIntoState(current: RootReducerState, persisted: PersistedRootState | null): RootReducerState {
  if (!persisted?.config) {
    return current;
  }
  return {
    ...current,
    config: {
      ...current.config,
      menu: persisted.config.menu ?? current.config.menu,
      pdf_generator: persisted.config.pdf_generator ?? current.config.pdf_generator,
    },
  };
}
